import { useMediaQuery, useTheme } from "@mui/material";
import { createContext, useContext, useReducer } from "react";

const LayoutStateContext = createContext<any>({});
const LayoutDispatchContext = createContext<any>({});

function layoutReducer(state, action) {
  switch (action.type) {
    case "TOGGLE_SIDEBAR":
      return { ...state, isSidebarOpened: !state.isSidebarOpened };
    case "OPEN_SIDEBAR":
        return { ...state, isSidebarOpened: true };
    case "CLOSE_SIDEBAR":
          return { ...state, isSidebarOpened: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function LayoutProvider({ children }: any) {
  const theme: any = useTheme();
  const mediumOrHigher = useMediaQuery(theme.breakpoints.up('md'));
  
  const [state, dispatch] = useReducer(layoutReducer, {
    isSidebarOpened: mediumOrHigher,
  });
  return (
    <LayoutStateContext.Provider value={state}>
      <LayoutDispatchContext.Provider value={dispatch}>
        {children}
      </LayoutDispatchContext.Provider>
    </LayoutStateContext.Provider>
  );
}

function useLayoutState() {
  const context = useContext(LayoutStateContext);
  if (context === undefined) {
    throw new Error("useLayoutState must be used within a LayoutProvider");
  }
  return context;
}

function useLayoutDispatch() {
  const context = useContext(LayoutDispatchContext);
  if (context === undefined) {
    throw new Error("useLayoutDispatch must be used within a LayoutProvider");
  }
  return context;
}

function useIsSmallSelector(): any {
  try {
    const theme = useTheme();
    const { isSidebarOpened } = useLayoutState();

    const smallSize = useMediaQuery(theme.breakpoints.down("sm"));
    const mediumSize = useMediaQuery(theme.breakpoints.down("md"));
    return (mediumSize && isSidebarOpened) || smallSize;
  } catch (err) {
    throw new Error(
      "useIsSmallSelector must be used within a functional component"
    );
  }
}

function useIsLargeSelector(): any {
  try {
    const theme = useTheme();

    const largeSize = useMediaQuery(theme.breakpoints.up("lg"));
    return largeSize;
  } catch (err) {
    throw new Error(
      "useIsLargeSelector must be used within a functional component"
    );
  }
}

function toggleSidebar(dispatch) {
  dispatch({
    type: "TOGGLE_SIDEBAR",
  });
}

function openSidebar(dispatch) {
  dispatch({
    type: "OPEN_SIDEBAR",
  });
}

function closeSidebar(dispatch) {
  dispatch({
    type: "CLOSE_SIDEBAR",
  });
}

export {
  LayoutProvider,
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
  openSidebar,
  closeSidebar,
  useIsSmallSelector,
  useIsLargeSelector,
};
